import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';
import { memo } from 'react';

/**
 * Animated SVG icon of an envelope.
 *
 * Converted to a React and Mui Component from icon_nl_subscribe_1_default.svg, but adjusted to fix
 * some positioning and sizing issues.
 *
 * You can pass SX props.
 */
const IconNlSubscribe1Default = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="100 80 200 200"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <style>
        {
          '@keyframes newsletter_icon_ani_layers-path1_ts__ts{0%,20%,33.333333%,53.333333%,66.666667%{transform:translate(200.599998px,270.299988px) scale(.742019,1);animation-timing-function:cubic-bezier(.42,0,1,1)}10%,43.333333%,76.666667%{transform:translate(200.599998px,270.299988px) scale(.947161,1);animation-timing-function:cubic-bezier(.42,0,1,1)}86.666667%,to{transform:translate(200.599998px,270.299988px) scale(.742019,1)}}@keyframes newsletter_icon_ani_layers-grundform_x5f_klappe_to__to{0%,20%,33.333333%,53.333333%,66.666667%{transform:translate(200.102539px,170.062485px);animation-timing-function:cubic-bezier(.42,0,1,1)}10%,43.333333%,76.666667%{transform:translate(200.102539px,200.062485px);animation-timing-function:cubic-bezier(.42,0,1,1)}86.666667%,to{transform:translate(200.102539px,170.062485px)}}@keyframes newsletter_icon_ani_layers-briefpapier_x5f_innenteil_to__to{0%,33.333333%,66.666667%{transform:translate(200.199997px,169.200005px);animation-timing-function:cubic-bezier(.42,0,1,1)}10%,43.333333%,76.666667%{transform:translate(200.199997px,199.200005px);animation-timing-function:cubic-bezier(.42,0,1,1)}16.666667%,50%,83.333333%{transform:translate(200.199997px,155.200005px);animation-timing-function:cubic-bezier(.42,0,1,1)}to{transform:translate(200.199997px,169.200005px)}}@keyframes newsletter_icon_ani_layers-vorderteil_x5f_oeffnung_to__to{0%,20%,33.333333%,53.333333%,66.666667%{transform:translate(200.300003px,187.450005px);animation-timing-function:cubic-bezier(.42,0,1,1)}10%,43.333333%,76.666667%{transform:translate(200.300003px,217.450005px);animation-timing-function:cubic-bezier(.42,0,1,1)}86.666667%,to{transform:translate(200.300003px,187.450005px)}}@keyframes newsletter_icon_ani_layers-path9_ts__ts{0%,90%,to{transform:translate(123.750011px,102.174011px) scale(0,0)}13.333333%,23.333333%,46.666667%,56.666667%,80%{transform:translate(123.750011px,102.174011px) scale(0,0);animation-timing-function:cubic-bezier(.42,0,1,1)}16.666667%,50%,83.333333%{transform:translate(123.750011px,102.174011px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}}@keyframes newsletter_icon_ani_layers-path10_ts__ts{0%,90%,to{transform:translate(135.106885px,120.346838px) scale(0,0)}13.333333%,23.333333%,46.666667%,56.666667%,80%{transform:translate(135.106885px,120.346838px) scale(0,0);animation-timing-function:cubic-bezier(.42,0,1,1)}16.666667%,50%,83.333333%{transform:translate(135.106885px,120.346838px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}}@keyframes newsletter_icon_ani_layers-path11_ts__ts{0%,90%,to{transform:translate(139.850006px,93.804626px) scale(0,0)}13.333333%,23.333333%,46.666667%,56.666667%,80%{transform:translate(139.850006px,93.804626px) scale(0,0);animation-timing-function:cubic-bezier(.42,0,1,1)}16.666667%,50%,83.333333%{transform:translate(139.850006px,93.804626px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}}@keyframes newsletter_icon_ani_layers-path12_ts__ts{0%,90%,to{transform:translate(276.050003px,102.209999px) scale(0,0)}13.333333%,23.333333%,46.666667%,56.666667%,80%{transform:translate(276.050003px,102.209999px) scale(0,0);animation-timing-function:cubic-bezier(.42,0,1,1)}16.666667%,50%,83.333333%{transform:translate(276.050003px,102.209999px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}}@keyframes newsletter_icon_ani_layers-path13_ts__ts{0%,90%,to{transform:translate(279.700012px,120.346836px) scale(0,0)}13.333333%,23.333333%,46.666667%,56.666667%,80%{transform:translate(279.700012px,120.346836px) scale(0,0);animation-timing-function:cubic-bezier(.42,0,1,1)}16.666667%,50%,83.333333%{transform:translate(279.700012px,120.346836px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}}@keyframes newsletter_icon_ani_layers-path14_ts__ts{0%,90%,to{transform:translate(259.949989px,93.783253px) scale(0,0)}13.333333%,23.333333%,46.666667%,56.666667%,80%{transform:translate(259.949989px,93.783253px) scale(0,0);animation-timing-function:cubic-bezier(.42,0,1,1)}16.666667%,50%,83.333333%{transform:translate(259.949989px,93.783253px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}}'
        }
      </style>
      <g id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-schatten">
        <g
          transform="matrix(.74202 0 0 1 200.6 270.3)"
          style={{
            animation: 'newsletter_icon_ani_layers-path1_ts__ts 3000ms linear 3 normal forwards',
          }}
          id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-g1"
        >
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path1"
            d="M255.199 261.8H138.573c-1.3 0-2.321-1.1-2.321-2.5s1.021-2.5 2.321-2.5H255.2c1.3 0 2.321 1.1 2.321 2.5s-1.021 2.5-2.321 2.5Z"
            transform="translate(-197.6 -259.3)"
            fill="#000"
            stroke="none"
            strokeWidth={1}
          />
        </g>
      </g>
      <g
        transform="translate(200.103 170.062)"
        style={{
          animation:
            'newsletter_icon_ani_layers-grundform_x5f_klappe_to__to 3000ms linear 3 normal forwards',
        }}
      >
        <g
          id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-grundform_x5f_klappe"
          transform="translate(-200.103 -170.062)"
        >
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path2"
            d="M263.1 144.8v75.4c0 5.6-4.5 10.1-10.1 10.1H147.4c-5.6 0-10.1-4.5-10.1-10.1v-75.4m125.8 0-54.3-32.6c-4.8-2.9-12.4-2.9-17.2 0l-54.3 32.6"
            fill="#FFF"
            stroke="none"
            strokeWidth={1}
          />
          <g id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-g2">
            <path
              id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path3"
              d="M253 232.7H147.4c-6.9 0-12.6-5.6-12.6-12.6v-75.7c0-.4.1-.7.3-1 .2-.3.4-.6.7-.8.1-.1.2-.1.2-.2l54.2-32.5c5.6-3.3 14.3-3.3 19.8 0l54.2 32.5c.1 0 .2.1.2.2.3.2.5.5.7.8.2.3.3.6.3 1v75.7c.2 7-5.5 12.6-12.4 12.6Zm-113.2-86.5v74c0 4.2 3.4 7.5 7.6 7.5H253c4.2 0 7.6-3.4 7.6-7.5v-74l-53-31.8c-4-2.4-10.7-2.4-14.6 0l-53.2 31.8Z"
              fill="#000"
              stroke="none"
              strokeWidth={1}
            />
          </g>
        </g>
      </g>
      <g
        transform="translate(200.2 169.2)"
        style={{
          animation:
            'newsletter_icon_ani_layers-briefpapier_x5f_innenteil_to__to 3000ms linear 3 normal forwards',
        }}
      >
        <g
          id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-briefpapier_x5f_innenteil"
          transform="translate(-200.2 -156.2)"
        >
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-polyline1"
            fill="#FFF"
            stroke="none"
            strokeWidth={1}
            d="M147.4 191.4v-70.3H253v70.3"
          />
          <g id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-g3">
            <path
              id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path4"
              d="M253 193.8c-1.4 0-2.5-1.1-2.5-2.5v-67.7H149.9v67.7c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-70.2c0-1.4 1.1-2.5 2.5-2.5H253c1.4 0 2.5 1.1 2.5 2.5v70.2c0 1.4-1.1 2.5-2.5 2.5Z"
              fill="#000"
              stroke="none"
              strokeWidth={1}
            />
          </g>
        </g>
      </g>
      <g
        transform="translate(200.3 187.45)"
        style={{
          animation:
            'newsletter_icon_ani_layers-vorderteil_x5f_oeffnung_to__to 3000ms linear 3 normal forwards',
        }}
      >
        <g
          id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-vorderteil_x5f_oeffnung"
          transform="translate(-200.3 -187.45)"
        >
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path5"
            d="M137.3 153.1v67.1c0 5.6 4.5 10.1 10.1 10.1H253c5.6 0 10.1-4.5 10.1-10.1V152.3l-54.3 32.6c-4.8 2.9-12.5 2.9-17.2 0l-54.3-32.6"
            fill="#FFF"
            stroke="none"
            strokeWidth={1}
          />
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path6"
            d="M263.1 142.2c-1.4 0-2.5 1.1-2.5 2.5v6.1l-53 31.8c-4 2.4-10.7 2.4-14.6 0l-53-31.8v-6.1c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v75.4c0 6.9 5.6 12.6 12.6 12.6H253c6.9 0 12.6-5.6 12.6-12.6v-75.4c0-1.4-1.1-2.5-2.5-2.5ZM253 227.7H147.4c-4.2 0-7.6-3.4-7.6-7.5v-63.5L182 182l-33.9 33.9c-1 1-1 2.6 0 3.6.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7l34.8-34.8 3.9 2.3c2.8 1.7 6.3 2.5 9.9 2.5 3.6 0 7.1-.8 9.9-2.5l3.9-2.3 34.8 34.8c.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7c1-1 1-2.6 0-3.6L218.4 182l42.2-25.3v63.5c-.1 4.1-3.4 7.5-7.6 7.5Z"
            fill="#000"
            stroke="none"
            strokeWidth={1}
          />
        </g>
      </g>
      <g id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-bings">
        <g
          transform="matrix(0 0 0 0 123.75 102.174)"
          style={{
            animation: 'newsletter_icon_ani_layers-path9_ts__ts 3000ms linear 3 normal forwards',
          }}
          id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-g7"
        >
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path9"
            d="M136.8 114.1c-.5 0-1-.2-1.5-.5l-26-18.8c-1.1-.8-1.4-2.4-.6-3.5.8-1.1 2.4-1.4 3.5-.6l26 18.8c1.1.8 1.4 2.4.6 3.5-.5.7-1.3 1.1-2 1.1Z"
            transform="translate(-123.75 -102.174)"
            fill="#000"
            stroke="none"
            strokeWidth={1}
          />
        </g>
        <g
          transform="matrix(0 0 0 0 135.107 120.347)"
          style={{
            animation: 'newsletter_icon_ani_layers-path10_ts__ts 3000ms linear 3 normal forwards',
          }}
          id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-g8"
        >
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path10"
            d="M132.6 123.7h-.2l-25-1.6c-1.4-.1-2.4-1.3-2.3-2.7.1-1.4 1.3-2.4 2.7-2.3l25 1.6c1.4.1 2.4 1.3 2.3 2.7-.1 1.2-1.2 2.3-2.5 2.3Z"
            transform="translate(-135.107 -120.347)"
            fill="#000"
            stroke="none"
            strokeWidth={1}
          />
        </g>
        <g
          transform="matrix(0 0 0 0 139.85 93.805)"
          style={{
            animation: 'newsletter_icon_ani_layers-path11_ts__ts 3000ms linear 3 normal forwards',
          }}
          id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-g9"
        >
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path11"
            d="M144.8 107.8c-1 0-1.9-.6-2.3-1.5l-9.9-23c-.5-1.3 0-2.8 1.3-3.3s2.8 0 3.3 1.3l9.9 23c.5 1.3 0 2.8-1.3 3.3-.4.1-.7.2-1 .2Z"
            transform="translate(-139.85 -93.805)"
            fill="#000"
            stroke="none"
            strokeWidth={1}
          />
        </g>
        <g
          transform="matrix(0 0 0 0 276.05 102.21)"
          style={{
            animation: 'newsletter_icon_ani_layers-path12_ts__ts 3000ms linear 3 normal forwards',
          }}
          id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-g10"
        >
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path12"
            d="M263 114.1c-.8 0-1.5-.4-2-1-.8-1.1-.6-2.7.6-3.5l26-18.8c1.1-.8 2.7-.6 3.5.6.8 1.1.6 2.7-.6 3.5l-26 18.8c-.5.2-1 .4-1.5.4Z"
            transform="translate(-276.05 -102.21)"
            fill="#000"
            stroke="none"
            strokeWidth={1}
          />
        </g>
        <g
          transform="matrix(0 0 0 0 279.7 120.347)"
          style={{
            animation: 'newsletter_icon_ani_layers-path13_ts__ts 3000ms linear 3 normal forwards',
          }}
          id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-g11"
        >
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path13"
            d="M267.2 123.7c-1.3 0-2.4-1-2.5-2.4-.1-1.4 1-2.6 2.3-2.7l25-1.6c1.4-.1 2.6 1 2.7 2.3.1 1.4-1 2.6-2.3 2.7l-25 1.6c-.1.1-.2.1-.2.1Z"
            transform="translate(-279.7 -120.347)"
            fill="#000"
            stroke="none"
            strokeWidth={1}
          />
        </g>
        <g
          transform="matrix(0 0 0 0 259.95 93.783)"
          style={{
            animation: 'newsletter_icon_ani_layers-path14_ts__ts 3000ms linear 3 normal forwards',
          }}
          id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-g12"
        >
          <path
            id="icon_nl_subscribe_1_default_svg__newsletter_icon_ani_layers-path14"
            d="M255 107.8c-.3 0-.7-.1-1-.2-1.3-.5-1.9-2-1.3-3.3l9.9-23c.5-1.3 2-1.9 3.3-1.3 1.3.5 1.9 2 1.3 3.3l-9.9 23c-.4.9-1.3 1.5-2.3 1.5Z"
            transform="translate(-259.95 -93.783)"
            fill="#000"
            stroke="none"
            strokeWidth={1}
          />
        </g>
      </g>
    </SvgIcon>
  );
};
const Memo = memo(IconNlSubscribe1Default);
// eslint-disable-next-line import/no-default-export
export default Memo;
